import type {OpeningCalendarData} from './types'
import type {AjaxService} from 'core/data-services/ajax.service';

/**
 * @ngdoc service
 * @name openingCalendarDataService
 * @module portaro.components.opening-calendar
 *
 * @requires object:openingCalendarApiUrl
 *
 * @description
 * Data service for {@link component:kpOpeningCalendar}
 */

export default class OpeningCalendarDataService {
    static serviceName = 'openingCalendarDataService';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService, private openingCalendarApiUrl: string) {
    }

    /**
     * @ngdoc method
     * @name openingCalendarDataService#getOpeningHours
     *
     * @param {string=} url API URI. Default value is taken from {@link object:openingCalendarApiUrl}
     * @param {number=} departmentId id for requesting particular department opening hours
     *
     * @return {Promise} Calendar data
     */
    public async getOpeningHours(url: string = this.openingCalendarApiUrl, departmentId?: number): Promise<OpeningCalendarData> {
        return this.ajaxService
            .createRequest(url)
            .get({department: departmentId});
    }
}